import type { ViewStyle } from "react-native";
import { View } from "react-native";

import Spinner from "$src/core/components/atoms/Spinner/Spinner";

import $ from "./LoadingPage.styles";

type Props = {
  style?: ViewStyle;
};

const LoadingPage: React.FC<Props> = ({ style }) => (
  <View style={[$.container, style]}>
    <Spinner />
  </View>
);

export default LoadingPage;
